module.exports = __webpack_public_path__ + "img/special_whiteningessence_202309.8d450ef6.jpg";